// src/app/App.tsx
import React from 'react';
import { RouterProvider } from 'react-router-dom';
import { router } from './routes';
import Providers from './Providers';
import { AuthProvider } from '@/shared/auth';
import { TenantProvider } from '@/shared/auth/tenantContext';
import { MENU } from '@/shared/navigation/menu';

function Fallback() {
  return (
    <div className="min-h-screen grid place-items-center bg-black text-neutral-300">
      <div className="animate-pulse">Loading…</div>
    </div>
  );
}

export default function App() {
  return (
    <Providers>
      {/* Session-aware auth (talks to /bff/auth/me) */}
      <AuthProvider fallbackMenu={MENU}>
        {/* Superadmin tenant-override context (GCP IAM impersonation pattern) */}
        <TenantProvider>
          <RouterProvider router={router} fallbackElement={<Fallback />} />
        </TenantProvider>
      </AuthProvider>
    </Providers>
  );
}
